import { useI18N } from '@susu/i18n/client'

import { ROLE, type Role } from '../contexts/CustomerHubContext'
import { isEmployeeEmail } from '../lib/isEmployeeEmail'

interface EmployeeBadgeProps {
  role?: Role
  email?: string | null
}

/**
 * Light-grey "Employee" pill shown next to the customer's name when the
 * customer's email is a @suitsupply.com address. Only visible to style
 * advisors — other roles (e.g. a shopper viewing their own hub) never see it.
 */
export function EmployeeBadge({ role, email }: EmployeeBadgeProps) {
  const { t } = useI18N()

  if (role !== ROLE.STYLE_ADVISOR || !isEmployeeEmail(email)) return null

  return (
    <div className="flex h-20 px-8 pb-1 items-center rounded-md bg-surface-secondary">
      <span className="text-text-secondary font-light text-xs leading-xs">
        {t('badge.employee')}
      </span>
    </div>
  )
}
